export default {
  template: '#product-category-template',
  ready: function() {
    var self = this;
    this.product_thumbnail_image = this.product ? this.$root.getDesignerHelper().imagePath + this.product.front_preview : '';
    this.product_image = this.product ? this.$root.getDesignerHelper().imagePath + this.product.front_base : '';

    this.$on('on-select-product', function(product) {
      self.selectedProduct(product);
    });
  },
  events: {},
  props: ['product'],
  data: function() {
    return {
      image: {
        front: {
          original: null,
          thumbnail: null,
          large: null
        },
        back: {
          original: null,
          thumbnail: null,
          large: null
        }
      },
      product_thumbnail_image: null,
      product_image: null,
      mock_index: -1,
      mock_id: -1,
      product_type: 'PRODUCT',
      dimensions: {
        front: {
          offsets: {
            width: '0px',
            height: '0px',
            top: '0px',
            left: '0px'
          },
          image: {
            height: '0px',
            width: '0px'
          }
        },
        back: {
          offsets: {
            width: '0px',
            height: '0px',
            top: '0px',
            left: '0px'
          },
          image: {
            height: '0px',
            width: '0px'
          }
        }
      },
      promo_product_skus: [],
      promo_text_product: 'PROMO',
      new_product_skus: ['FACEMASK', 'NECKGAITER'],
      new_text_product: 'NEW PRODUCT'
    };
  },
  methods: {
    getProductName: function(product) {
      return product.name;
    },
    setNextMock: function() {
      var index = this.mock_index + 1;
      if (index > this.product.products_mocks.length - 1) {
        var productObj = this.product;
        this.image.front.thumbnail = productObj.front_preview;
        this.image.front.original = productObj.front_base;
        this.image.front.large = productObj.front_base_large;
        this.image.back.thumbnail = productObj.back_preview;
        this.image.back.original = productObj.back_base;
        this.image.back.large = productObj.back_base_large;
        this.product_thumbnail_image = this.$root.getDesignerHelper().imagePath + this.image.front.thumbnail;
        this.product_image = this.$root.getDesignerHelper().imagePath + this.image.front.original;
        this.mock_index = -1;
        this.mock_id = null;
        this.$set('dimensions', this.getProductDimensions(productObj));
        this.product_type = "PRODUCT";
      } else {
        var mockObj = this.product.products_mocks[index];
        this.image.front.thumbnail = mockObj.front_preview;
        this.image.front.original = mockObj.front_base;
        this.image.front.large = mockObj.front_base_large;
        this.image.back.thumbnail = mockObj.back_preview;
        this.image.back.original = mockObj.back_base;
        this.image.back.large = mockObj.back_base_large;
        this.product_thumbnail_image = this.$root.getDesignerHelper().imagePath + this.image.front.thumbnail;
        this.product_image = this.$root.getDesignerHelper().imagePath + this.image.front.original;
        this.mock_index = index;
        this.mock_id = mockObj.id;
        this.$set('dimensions', this.getProductMockDimensions(mockObj));
        this.product_type = "MOCK";
      }
    },
    setPreviousMock: function() {
      var index = this.mock_index - 1;

      if (index === -1) {
        var productObj = this.product;
        this.image.front.thumbnail = productObj.front_preview;
        this.image.front.original = productObj.front_base;
        this.image.front.large = productObj.front_base_large;
        this.image.back.thumbnail = productObj.back_preview;
        this.image.back.original = productObj.back_base;
        this.image.back.large = productObj.back_base_large;
        this.product_thumbnail_image = this.$root.getDesignerHelper().imagePath + this.image.front.thumbnail;
        this.mock_index = -1;
        this.mock_id = null;
        this.$set('dimensions', this.getProductDimensions(productObj));
        this.product_type = "PRODUCT";
      } else {
        if (index === -2) {
          index = this.product.products_mocks.length - 1
        }
        var mockObj = this.product.products_mocks[index];
        this.image.front.thumbnail = mockObj.front_preview;
        this.image.front.original = mockObj.front_base;
        this.image.front.large = mockObj.front_base_large;
        this.image.back.thumbnail = mockObj.back_preview;
        this.image.back.original = mockObj.back_base;
        this.image.back.large = mockObj.back_base_large;
        this.product_thumbnail_image = this.$root.getDesignerHelper().imagePath + this.image.front.thumbnail;
        this.mock_index = index;
        this.mock_id = mockObj.id;
        this.$set('dimensions', this.getProductMockDimensions(mockObj));
        this.product_type = "MOCK";
      }
    },
    selectProduct: function(override_product) {
      var currentProduct = this.$root.selectedProduct,
        product = override_product ? override_product : this.product;
      if (currentProduct) {
        if (currentProduct.product.sublimation != product.sublimation && (this.$root.designerItems.front.length > 0 || this.$root.designerItems.back.length > 0)) {
          var that = this;
          helpers.confirm('This will clear the existing design. Would you like to proceed?', function() {
            that.$root.$set('designerItems.front', []);
            that.$root.$set('designerItems.back', []);
            that.onProductSelected();
          });
        } else {
          this.onProductSelected();
        }
      }
    },
    onProductSelected: function(product) {
      if (this.product_type == "PRODUCT") {
        var productObj = this.product;
        this.dimensions = this.getProductDimensions(productObj);
        this.image.front.thumbnail = productObj.front_preview;
        this.image.front.original = productObj.front_base;
        this.image.front.large = productObj.front_base_large;
        this.image.back.thumbnail = productObj.back_preview;
        this.image.back.original = productObj.back_base;
        this.image.back.large = productObj.back_base_large;
      }
      this.$root.selectProduct(this.$data, true);
      $('#choose_product_modal').modal('hide');
    },
    getProductDimensions: function(productObj) {
      return {
        front: {
          offsets: {
            height: productObj.front_height + 'px',
            width: productObj.front_width + 'px',
            left: productObj.front_left + 'px',
            top: productObj.front_top + 'px'
          },
          image: {
            width: productObj.front_image_width + 'px',
            height: productObj.front_image_height + 'px'
          }
        },
        back: {
          offsets: {
            height: productObj.back_height + 'px',
            width: productObj.back_width + 'px',
            left: productObj.back_left + 'px',
            top: productObj.back_top + 'px'
          },
          image: {
            width: productObj.back_image_width + 'px',
            height: productObj.back_image_height + 'px'
          }
        }
      }
    },
    getProductMockDimensions: function(mockObj) {
      return {
        front: {
          offsets: {
            height: mockObj.front_height + 'px',
            width: mockObj.front_width + 'px',
            left: mockObj.front_left + 'px',
            top: mockObj.front_top + 'px'
          },
          image: {
            width: mockObj.front_image_width + 'px',
            height: mockObj.front_image_height + 'px'
          }
        },
        back: {
          offsets: {
            height: mockObj.back_height + 'px',
            width: mockObj.back_width + 'px',
            left: mockObj.back_left + 'px',
            top: mockObj.back_top + 'px'
          },
          image: {
            width: mockObj.back_image_width + 'px',
            height: mockObj.back_image_height + 'px'
          }
        }
      }
    },
    getProductImage: function(product) {
      return this.$root.getDesignerHelper().imagePath + product.products.front_preview;
    },
    getProductInfo() {
      this.$dispatch('on-product-show-info', this.product);
    },
    isProductInPromo(product) {

      if (this.skipProductPromoForShopifyApp()) {

        return false;
      }

      return $.inArray(product.sku, this.promo_product_skus) > -1;
    },
    isProductNew(product) {
      return $.inArray(product.sku, this.new_product_skus) > -1;
    },
    skipProductPromoForShopifyApp() {

      return this.isAPIOrder();
    },
    isAPIOrder: function() {

      return this.$root.isAPIOrder();
    },
  }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/productObject.js